import { render, staticRenderFns } from "./EventComponent.vue?vue&type=template&id=6311be26&scoped=true&"
import script from "./EventComponent.vue?vue&type=script&lang=js&"
export * from "./EventComponent.vue?vue&type=script&lang=js&"
import style0 from "./EventComponent.vue?vue&type=style&index=0&id=6311be26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311be26",
  null
  
)

export default component.exports